/* Amalia J & Boutique – Jewish calendar: holiday list in date order (next one first) and Shabbat on every Friday.
   Loads after amj-jw-calendar.js. Uses @hebcal/core (GPLv2) loaded as window.hebcal. */
(function () {
  var cfgEl = document.getElementById('amj-jw-config');
  if (!cfgEl || !window.hebcal) return;
  var C = JSON.parse(cfgEl.textContent);
  var H = window.hebcal, HC = H.HebrewCalendar, F = H.flags;
  var ES = C.lang === 'es';
  var DOW = ES ? ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'] : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MON = ES ? ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'] : ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  function lbl(d) { return ES ? DOW[d.getDay()] + ' ' + d.getDate() + ' de ' + MON[d.getMonth()] + ' de ' + d.getFullYear() : DOW[d.getDay()] + ', ' + MON[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear(); }
  function fmtTime(t) { if (!t) return ''; var p = t.split(':'), h = +p[0], m = p[1]; if (ES) return h + ':' + m; return ((h + 11) % 12 + 1) + ':' + m + (h < 12 ? ' am' : ' pm'); }
  function addDays(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; }
  function parseIso(k) { var p = k.split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }
  var today = new Date(); today.setHours(0, 0, 0, 0);
  var first = new Date(C.year, C.month - 1, 1);
  var byUrl = {}, shab = null;
  C.holidays.forEach(function (h) { byUrl[h.url] = h; if (h.keys.indexOf('Parashat') >= 0) shab = h; });

  /* ---------- holiday list: chronological, starting with the next one ---------- */
  var wrap = document.querySelector('.amj-jw__hgrid, .amj-jw__hols');
  if (wrap) {
    // Current month (or home page): from today. Other months: from the 1st of that month.
    var ref = today > first ? today : first;
    var evs = HC.calendar({ start: ref, end: addDays(ref, 400), il: false });
    var cards = [].slice.call(wrap.children).filter(function (a) { return byUrl[a.getAttribute('href')]; });
    cards.forEach(function (card) {
      var h = byUrl[card.getAttribute('href')], when = null, txt = '';
      if (h === shab) {
        when = addDays(ref, (5 - ref.getDay() + 7) % 7);
        txt = (ES ? 'Todos los viernes al atardecer · el próximo: ' : 'Every Friday at sundown · next: ') + lbl(when);
      } else {
        var hit = null;
        for (var i = 0; i < evs.length && !hit; i++) {
          var e = evs[i], desc = e.getDesc();
          if ((e.getFlags() & F.EREV) || /Katan|LaBehemot/.test(desc)) continue;
          for (var k = 0; k < h.keys.length; k++) { if (desc === h.keys[k] || desc.indexOf(h.keys[k]) === 0) { hit = e; break; } }
        }
        if (hit) {
          var d = hit.getDate().greg();
          if ((hit.getFlags() & F.MINOR_FAST) && !/Yom Kippur|Tish'a B'Av/.test(hit.getDesc())) { when = d; txt = lbl(d); }
          else { when = addDays(d, -1); txt = (ES ? 'Desde la noche del ' : 'From the evening of ') + lbl(when); }
        }
      }
      card.setAttribute('data-t', when ? when.getTime() : 9e15);
      var out = card.querySelector('[data-next]');
      if (!out) {
        out = document.createElement('em'); out.setAttribute('data-next', '');
        out.style.cssText = 'font-style:normal;font-size:13px;color:#1F3A6B;font-weight:700';
        var s = card.querySelector('strong'); s ? s.after(out) : card.prepend(out);
      }
      out.textContent = txt;
    });
    cards.sort(function (a, b) { return a.getAttribute('data-t') - b.getAttribute('data-t'); }).forEach(function (c) { wrap.appendChild(c); });
  }

  /* ---------- grid: Shabbat begins every Friday ---------- */
  var grid = document.getElementById('amj-jw-grid');
  function cityLoc() {
    var n = 'Miami'; try { n = localStorage.getItem('amj-jw-city') || n; } catch (e) { }
    return window.AMJ_JW ? window.AMJ_JW.parseLoc(n) : null;
  }
  function markFridays() {
    var cells = grid.querySelectorAll('.amj-jw__cell[data-date]:not([data-fri])');
    if (!cells.length) return;
    var loc = cityLoc();
    cells.forEach(function (cell) {
      cell.setAttribute('data-fri', '');
      var d = parseIso(cell.getAttribute('data-date'));
      if (d.getDay() !== 5) return;
      var t = '';
      if (loc) HC.calendar({ start: d, end: d, location: loc, candlelighting: true, il: false }).forEach(function (e) { if (e.getDesc() === 'Candle lighting' && !t) t = e.eventTimeStr; });
      cell.classList.add('amj-jw__cell--shabbat');
      var s = document.createElement('span');
      s.className = 'amj-jw__ev amj-jw__ev--parsha';
      s.textContent = (ES ? 'Shabat' : 'Shabbat') + (t ? ' · ' + (ES ? 'velas ' : 'candles ') + fmtTime(t) : '');
      var dow = cell.querySelector('.amj-jw__dow');
      dow ? dow.after(s) : cell.appendChild(s);
    });
  }

  /* ---------- day panel: on Fridays, "Shabbat begins at sundown" ---------- */
  var panel = document.getElementById('amj-jw-panel');
  function panelFriday() {
    if (panel.hidden || panel.querySelector('[data-fri]')) return;
    var sel = grid && grid.querySelector('.amj-jw__cell--sel');
    if (!sel || parseIso(sel.getAttribute('data-date')).getDay() !== 5) return;
    var box = panel.querySelector('.amj-jw__box'); if (!box) return;
    var ul = box.querySelector(':scope > .amj-jw__list:not(.amj-jw__list--small)');
    if (!ul) {
      ul = document.createElement('ul'); ul.className = 'amj-jw__list';
      var none = box.querySelector(':scope > p:not([class])');
      none ? none.replaceWith(ul) : box.insertBefore(ul, box.children[1] || null);
    }
    var li = document.createElement('li'); li.setAttribute('data-fri', '');
    var txt = ES ? 'Shabat comienza al atardecer' : 'Shabbat begins at sundown';
    if (shab) { var a = document.createElement('a'); a.href = shab.url; a.textContent = txt; li.appendChild(a); } else li.textContent = txt;
    ul.insertBefore(li, ul.firstChild);
  }

  if (grid) { markFridays(); new MutationObserver(markFridays).observe(grid, { childList: true }); }
  if (panel) { panelFriday(); new MutationObserver(panelFriday).observe(panel, { childList: true, attributes: true, attributeFilter: ['hidden'] }); }
})();
